import { ExperienceCategory } from "modules/PsyCatalog/common/ExperienceCategory"

export function getSessionCountText(category: ExperienceCategory) {
    return `Более ${ExperienceCategory[category]} сессий в\u00A0Alter`
}
